import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CaqRequestService } from '..'
import { map, firstValueFrom } from 'rxjs';
import { MediaAlunosPorTurmaDto } from '../../dtos/media-alunos-por-turma.dto';
import { TipoSimulacao } from '../../enums/simulation-type.enum';

interface ListMediaAlunosPorTurmaPorLocalizacaoDto {
  content: MediaAlunosPorTurmaDto[];
}

@Injectable({
  providedIn: 'root',
})
export class MediaAlunosPorTurmaService {
  private apiUrl = `${environment.apiUrl}/condicoes-de-qualidade`;

  constructor(
    private caqRequestService: CaqRequestService
  ) { }

  async buscarMediaAlunosPorTurmaMunicipal(codMun?: number | string, escopo?: number): Promise<MediaAlunosPorTurmaDto[]> {
    if (!codMun) return [];

    const url =
      escopo === TipoSimulacao.planejamento
        ? `${this.apiUrl}/alunos-por-turma-no-plano-municipal/${codMun}`
        : `${this.apiUrl}/alunos-por-turma-na-rede-municipal/${codMun}`;

    return firstValueFrom(
      this.caqRequestService
        .get<ListMediaAlunosPorTurmaPorLocalizacaoDto>(url)
        .pipe(map(res => res.content ?? []))
    );
  }

  async buscarMediaAlunosPorTurmaEstadual(codigoEstado: string, escopo: number | undefined): Promise<MediaAlunosPorTurmaDto[]> {
    if (!codigoEstado) return [];

    const url =
      escopo === TipoSimulacao.planejamento
        ? `${this.apiUrl}/alunos-por-turma-no-plano-estadual/${codigoEstado}`
        : `${this.apiUrl}/alunos-por-turma-na-rede-estadual/${codigoEstado}`;

    return firstValueFrom(
      this.caqRequestService
        .get<ListMediaAlunosPorTurmaPorLocalizacaoDto>(url)
        .pipe(map(res => res.content ?? []))
    );
  }

  async buscarMediaAlunosPorTurmaNacional(): Promise<MediaAlunosPorTurmaDto[]> {
    return firstValueFrom(
      this.caqRequestService
        .get<ListMediaAlunosPorTurmaPorLocalizacaoDto>(`${this.apiUrl}/alunos-por-turma-no-plano-nacional`)
        .pipe(map(res => res.content ?? []))
    );
  }
}
